var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.4444C8.25185 12.4444 8.46311 12.3591 8.63378 12.1884C8.80445 12.0178 8.88948 11.8068 8.88889 11.5556C8.8883 11.3043 8.80296 11.0933 8.63289 10.9227C8.46281 10.752 8.25185 10.6667 8 10.6667C7.74815 10.6667 7.53719 10.752 7.36711 10.9227C7.19704 11.0933 7.1117 11.3043 7.11111 11.5556C7.11052 11.8068 7.19585 12.0181 7.36711 12.1893C7.53837 12.3606 7.74933 12.4456 8 12.4444ZM7.11111 8.88889H8.88889V3.55556H7.11111V8.88889ZM4.66667 16L0 11.3333V4.66667L4.66667 0H11.3333L16 4.66667V11.3333L11.3333 16H4.66667ZM5.42222 14.2222H10.5778L14.2222 10.5778V5.42222L10.5778 1.77778H5.42222L1.77778 5.42222V10.5778L5.42222 14.2222Z",
    fill: "#E4151B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport1);
export default __webpack_public_path__ + "static/media/report1.13efc995e696612c63f968a829d246f7.svg";
export { ForwardRef as ReactComponent };